import React from 'react';
import './PaginationDropdown.scss';
import { IPaginationDropdownProps } from './IPaginationDropdownProps';

const PaginationDropdown: React.FC<IPaginationDropdownProps> = (props) => {

  const [selectedPage, setSelectedPage] = React.useState<number>(props.currentPage);

    React.useEffect(() => {
        setSelectedPage(props.currentPage);
    }, [props.currentPage])

  const generateNumberArray = (lastPage: number): number[] => {
    if (lastPage < 1) {
      throw new Error("lastPage must be a positive integer.");
    }
  
    return Array.from({ length: lastPage }, (_, index) => index + 1);
  }

    const pages = generateNumberArray(props.lastPage);

  return (
    <div className='gp-pagination-dropdown-footer'>
        <button
            onClick={() => {
                setSelectedPage(selectedPage - 1);
                props.onPageChanged(selectedPage - 1)
            }}
            disabled={selectedPage <= 1}
            className={`previous ${(selectedPage <= 1) ? 'disable' : ''}`}
        >
            Prev
        </button>{' '}
        <div className='center'>
            <select
                onChange={(e: any) => {
                    setSelectedPage(Number(e.target.value));
                    props.onPageChanged(Number(e.target.value));
                }}
                className='page-button'
                value={selectedPage}
            >
                {pages.map((page: any) => (
                    <option key={page} value={page}>
                        {page}
                    </option>
                ))}
            </select>
        </div>
        <button
            className={`next ${selectedPage == props.lastPage ? 'disable' : ''}`}
            onClick={() => {
                setSelectedPage(selectedPage + 1);
                props.onPageChanged(selectedPage + 1);
            }}
            disabled={selectedPage == props.lastPage}
        >
            Next
        </button>{' '}
    </div>
  )
}

export default PaginationDropdown;